import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { QuestionFormValues } from '@/utils/forms/questionTransformers';

export function CustomOptionsInitializer() {
  const { values, setFieldValue } = useFormikContext<QuestionFormValues>();
  const prevQuestionTypeRef = useRef(values.question_type);

  useEffect(() => {
    const currentType = values.question_type;
    const prevType = prevQuestionTypeRef.current;

    if (currentType === 'custom' && prevType !== 'custom') {
      setFieldValue('options', [
        {
          option_text_en: '',
          option_text_fr: '',
          option_image_en: undefined,
          option_image_fr: undefined,
          third_image_en: undefined,
          third_image_fr: undefined,
          start_utc: undefined,
          is_correct: false,
          display_order: 0,
        },
        {
          option_text_en: '',
          option_text_fr: '',
          option_image_en: undefined,
          option_image_fr: undefined,
          third_image_en: undefined,
          third_image_fr: undefined,
          start_utc: undefined,
          is_correct: false,
          display_order: 1,
        },
      ] as QuestionFormValues['options']);
    }

    prevQuestionTypeRef.current = currentType;
  }, [values.question_type, setFieldValue]);

  return null;
}
